import moment from "moment";

/**
 * Formats valid strings to the "short date" format.
 *
 * @param val {any}: Any value passed to function is checked for truthiness before attempting to convert to moment date.
 * @return {string}: Returns a formatted date string or a dash indicating falsely value.
 */
const formatShortDate = (val) => {
    return val ? moment(val).format('MM/D/YY') : '---';
};

export default formatShortDate;
